import { styled } from '@mui/material/styles';
import { TextField, Typography } from '@mui/material';
import { COLOR } from '@src/styles/color';

const { MOBILE_BREAKPOINT, BREAKPOINTS } = require('@src/styles/config');

export const StyledReferralContainer = styled('div')`
  .referral-card {
    padding: 32px 48px;
    margin: 16px 4px;

    @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
      padding: 20px;
      margin: 8px 0;
      display: flex;
      gap: 24px;
    }

    @media only screen and (max-width: ${BREAKPOINTS.MXS}px) {
      padding: 0;
    }
  }
`;

export const StyledReferralDialogInput = styled(TextField)`
  .MuiInputBase-input {
    padding: 12px 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    vertical-align: middle;
  }
  .MuiFilledInput-root {
    background-color: ${COLOR.lightGray};
    border-radius: 8px;
    border: none;
  }

  .MuiTextField-root:hover {
    border: none;
  }

  .MuiFilledInput-root:after {
    border-bottom: none;
  }

  .MuiFilledInput-root:before {
    border-bottom: none;
  }

  .MuiFilledInput-root:hover:not(.Mui-disabled):before {
    border-bottom: none;
  }
`;

export const StyledReferralDialogNote = styled('div')`
  min-height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  background-color: ${(props) => props.backgroundColor || '#007aff14'};
  box-sizing: border-box;

  .warning-wrapper {
    background-color: #007aff14 !important;
  }

  .note-icon {
    color: #007aff;
    width: 20px;
    height: 20px;
  }

  .note-icon-warning {
    color: ${COLOR.alert};
    width: 20px;
    height: 20px;
  }

  .note-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    vertical-align: middle;
    color: ${COLOR.darkGray};
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .note-text {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.4px;
      vertical-align: middle;
    }
  }
`;

export const StyledReferralDialogErrorMessage = styled(Typography)`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.4px;
  vertical-align: middle;
  color: ${COLOR.red};
`;

export const StyledReferralDialogContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .character-container {
    margin: 16px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    .character {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: -0.4px;
      vertical-align: middle;
      color: ${COLOR.darkGray};
    }
    .unit {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.4px;
      vertical-align: middle;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .character-container {
      margin: 0;
    }
  }
`;

export const StyledReferralErrorDialogContent = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;

  .description {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    text-align: center;
    vertical-align: middle;
    color: ${COLOR.darkGray};
    max-width: 350px;
  }
`;

export const StyledReferralErrorDialogAction = styled('div')`
  .button {
    margin: 0;
    border-radius: 12px;
  }
`;
